interface LoadingScreenProps {
  /** Optional message below the animation */
  message?: string;
  /** Use compact mode for inline/section loading (no min-h-screen) */
  compact?: boolean;
}

function Spinner({ size }: { size: 'sm' | 'lg' }) {
  const className = size === 'sm' ? 'size-8 border-[3px]' : 'size-12 border-4';

  return (
    <span
      className={`${className} inline-block animate-spin rounded-full border-primary-200 border-t-primary-500`}
      aria-hidden="true"
    />
  );
}

export function LoadingScreen({ message, compact }: LoadingScreenProps) {
  if (compact) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <Spinner size="sm" />
        {message && (
          <p className="mt-3 text-sm text-charcoalGray-400 dark:text-white/40">{message}</p>
        )}
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-1000 dark:bg-grey-900">
      <div className="flex flex-col items-center">
        <Spinner size="lg" />
        {message && (
          <p className="mt-4 text-sm text-charcoalGray-400 dark:text-white/40">{message}</p>
        )}
      </div>
    </div>
  );
}
